/** @jsx jsx */
import { memo } from 'react';
import { differenceInDays, endOfDay, startOfDay, parseISO } from 'date-fns';
import { cssMap, jsx } from '@atlaskit/css';
import { ColoredDueDate } from '@atlassian/jira-coloured-due-date/src/ui/index.tsx';

type Props = {
	dueDate: string;
	isDone: boolean;
};

export const CardDueDate = memo(({ dueDate, isDone }: Props) => {
	const dueDateEndOfDay = endOfDay(parseISO(dueDate));
	const currentDate = startOfDay(new Date());
	const diffInDays = differenceInDays(dueDateEndOfDay, currentDate);

	return (
		<div css={styles.root}>
			<ColoredDueDate
				dateString={dueDate}
				pastDue={!isDone && diffInDays < 0}
				dueToday={diffInDays === 0}
			/>
		</div>
	);
});

const styles = cssMap({
	root: {
		display: 'flex',
		alignItems: 'center',
		// These styles allow elements to receive pointer events even with the use of the
		// InteractionLayer component in the board card component. The InteractionLayer
		// component is used to create a clickable area for the card, but we want to
		// ensure that certain elements within the card can still receive pointer events.
		position: 'relative',
		pointerEvents: 'auto',
	},
});
